import { AbstractControl, ValidationErrors } from "@angular/forms";

export class ValidationUtils {
    static readonly validatePhonenumber = (c: AbstractControl): ValidationErrors | null => {
        const regexp = new RegExp(/^\+\d+/);
        if (!regexp.test(c.value)) {
            return { nonValidPhonenumber: true };
        } else {
            return null;
        }
    };
}
